import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import SiteManagement from "./pages/SiteManagement";
import Dashboard from "./pages/Dashboard";
import SiteConfiguration from "./pages/SiteConfiguration";
import ConfigOverview from "./pages/ConfigOverview";
import SignalSettings from "./pages/SignalSettings";
import SignalMatch from "./pages/SignalMatch";
import DataImport from "./pages/DataImport";
import PerformanceReport from "./pages/PerformanceReport";
import InverterAvailability from "./pages/InverterAvailability";
import ModbusMapping from "./pages/ModbusMapping";
import ModbusStatus from "./pages/ModbusStatus";
import ScadaAnalytics from "./pages/ScadaAnalytics";
import SiteHierarchy from "./pages/hierarchy/SiteHierarchy";
import TransformerView from "./pages/hierarchy/TransformerView";
import TrackerStatusPage from "./pages/tracker/TrackerStatusPage";
import TrackerReportsPage from "./pages/tracker/TrackerReportsPage";
import DataMaintenance from "./pages/DataMaintenance";
import ReportsPage from "./pages/maintenance/ReportsPage";
import IecPrReportsPage from "./pages/maintenance/IecPrReportsPage";
import MaintenanceTicketsPage from "./pages/maintenance/tickets/MaintenanceTicketsPage";
import TicketDetailPage from "./pages/maintenance/tickets/TicketDetailPage";
import Landing from "./pages/Landing";
import LegalPage from "./pages/LegalPage";
import Login from "./pages/Login";
import Organizations from "./pages/admin/Organizations";
import Users from "./pages/admin/Users";
import OrgSiteAssignments from "./pages/admin/OrgSiteAssignments";
import UserSiteAssignments from "./pages/admin/UserSiteAssignments";
import { useAuth } from "./auth/AuthContext";

function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) return <div className="p-6">Loading...</div>;
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-6">Loading...</div>;
  if (!user || user.user_role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/imprint" element={<LegalPage type="imprint" />} />
        <Route path="/privacy" element={<LegalPage type="privacy" />} />
        <Route path="/cookies" element={<LegalPage type="cookies" />} />
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/maintenance/sites" element={<SiteManagement />} />
          <Route path="/maintenance/reports" element={<ReportsPage />} />
          <Route path="/maintenance/iec-pr-reports" element={<IecPrReportsPage />} />
          <Route path="/maintenance/tracker-reports" element={<TrackerReportsPage />} />
          <Route path="/maintenance/tickets" element={<MaintenanceTicketsPage />} />
          <Route path="/maintenance/tickets/:ticketId" element={<TicketDetailPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/tracker-status" element={<TrackerStatusPage />} />

          {/* scaffolds for later */}
          <Route path="/maintenance/config" element={<ConfigOverview />} />
          <Route path="/maintenance/signals" element={<SignalSettings />} />
          <Route path="/maintenance/signal-match" element={<SignalMatch />} />
          <Route path="/data/import" element={<DataImport />} />
          <Route path="/data/modbus/mapping" element={<ModbusMapping />} />
          <Route path="/data/modbus/status" element={<ModbusStatus />} />
          <Route path="/data/scada/analytics" element={<ScadaAnalytics />} />
          <Route path="/data/maintenance" element={<DataMaintenance />} />
          <Route path="/reports/performance" element={<PerformanceReport />} />
          <Route path="/reports/inverter-availability" element={<InverterAvailability />} />
          <Route path="/maintenance/site-config/:siteId" element={<SiteConfiguration />} />
          <Route path="/dashboard/hierarchy" element={<SiteHierarchy />} />
          <Route path="/dashboard/hierarchy/transformer/:transformerId" element={<TransformerView />} />

          {/* Admin */}
          <Route
            path="/admin/organizations"
            element={
              <AdminRoute>
                <Organizations />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <AdminRoute>
                <Users />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/org-sites"
            element={
              <AdminRoute>
                <OrgSiteAssignments />
              </AdminRoute>
            }
          />
          <Route
            path="/admin/user-sites"
            element={
              <AdminRoute>
                <UserSiteAssignments />
              </AdminRoute>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
